import http from 'plugins/axios';

export default {
  submitTransaction(data) {
    return http.post({
      url: '/admin/workorder/manual_deposit',
      data,
      dataType: 'form'
    });
  }
};
